import { config } from './config';

/** Fetch the (auth-cookied) CSV and trigger a browser download. */
export async function downloadReportCsv(query: string): Promise<void> {
  const res = await fetch(`${config.apiBaseUrl}/api/reports/export.csv${query}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Export failed');
  const blob = await res.blob();
  const dispo = res.headers.get('Content-Disposition') ?? '';
  const filename = /filename="(.+?)"/.exec(dispo)?.[1] ?? 'foodstyles-report.csv';
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
